<template>
  <div class="size-chart-view">
    <div class="scv-top-bar">
      <button class="clear-task-btn" @click="onClearTask">清空任务</button>
    </div>
    <div class="scv-tabs">
      <button
        v-for="(product, pi) in workbench.products"
        :key="pi"
        class="scv-tab"
        :class="{ active: activeTab === pi }"
        @click="activeTab = pi"
      >{{ product.name }}</button>
    </div>
    <div class="scv-content">
      <SizeChartForm :product-index="activeTab" />
      <SizeChartResult :product-index="activeTab" />
    </div>
    <div class="scv-clear-row">
      <button class="clear-product-btn" @click="workbench.clearProduct(activeTab)">
        清空当前产品（{{ workbench.products[activeTab]?.name }}）
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useWorkbenchStore } from '@/stores/useWorkbenchStore'
import SizeChartForm from '@/components/size-chart/SizeChartForm.vue'
import SizeChartResult from '@/components/size-chart/SizeChartResult.vue'

const workbench = useWorkbenchStore()
const activeTab = ref(0)

const onClearTask = () => {
  if (!confirm('确定要清空当前任务吗？\n\n所有产品（A/B/C）的上传图片和所有生成结果都会被删除，且无法恢复。')) return
  workbench.clearAllTask()
}
</script>

<style scoped>
.size-chart-view {
  padding: 0 24px 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.scv-top-bar {
  display: flex;
  justify-content: flex-end;
}
.scv-tabs {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 200px;
}
.scv-tab {
  padding: 8px 28px;
  border: 1px solid #e5e6eb;
  border-radius: 6px;
  background: #fff;
  color: #4e5969;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.15s;
}
.scv-tab:hover { border-color: #165dff; color: #165dff; }
.scv-tab.active {
  background: #165dff; color: #fff; border-color: #165dff; font-weight: 600;
}
.scv-content {
  display: flex;
  gap: 24px;
}
.scv-content > * {
  flex: 1;
  min-width: 0;
}
.scv-clear-row {
  display: flex;
  justify-content: flex-end;
}
</style>
